module.exports = __webpack_public_path__ + "bc0933566351167135717d014aee9fe8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/16_D#3.mp3
// module id = 74
// module chunks = 0